export default __webpack_public_path__ + "static/media/logo-caixa-rodape.239f787c.svg";